import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNpay = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 24,
	viewBox: "0 0 48 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", {
		id: "Type=Naver Pay",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Vector",
			clipPath: "url(#clip0_13_5710_npay_dark)",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Group",
				children: [/* @__PURE__ */ _jsx("g", {
					id: "Group_2",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Vector_2",
						d: "M18.4187 11.7094C18.4187 12.8386 18.0839 13.9424 17.4566 14.8813C16.8292 15.8202 15.9375 16.552 14.8942 16.9841C13.851 17.4162 12.703 17.5293 11.5955 17.309C10.488 17.0887 9.47071 16.545 8.67224 15.7465C7.87377 14.948 7.33 13.9307 7.10971 12.8232C6.88941 11.7157 7.00247 10.5677 7.4346 9.52448C7.86673 8.48123 8.59851 7.58955 9.53741 6.9622C10.4763 6.33485 11.5802 6 12.7094 6C14.2236 6 15.6758 6.60152 16.7465 7.67224C17.8172 8.74295 18.4187 10.1951 18.4187 11.7094ZM13.6643 9.02596V11.8963L11.666 9.02596H10.026V14.3999H11.753V11.521L13.7513 14.3928H15.3971V9.02596H13.6643Z",
						fill: "#00DE5A"
					})
				}), /* @__PURE__ */ _jsx("g", {
					id: "Group_3",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Vector_3",
						d: "M39.1246 8.72776L37.5316 12.3577L35.7295 8.72776H34.344L36.8961 13.7638L35.844 16.1236H37.1895L40.4701 8.73492L39.1246 8.72776ZM33.4585 14.3409H32.1417V13.8168C31.6626 14.2367 31.0451 14.4642 30.4083 14.4555C28.8338 14.4555 27.6015 13.1667 27.6015 11.5343C27.6015 9.90194 28.8324 8.61321 30.4083 8.61321C31.0449 8.60404 31.6624 8.83104 32.1417 9.25041V8.72776H33.4585V14.3409ZM32.2962 11.5415C32.2962 10.4833 31.5577 9.67999 30.5786 9.67999C29.5996 9.67999 28.861 10.4833 28.861 11.5415C28.861 12.5997 29.5982 13.403 30.5786 13.403C31.5591 13.403 32.2962 12.5925 32.2962 11.5415ZM21.0893 16.1236H22.4633V13.8641C22.9335 14.2552 23.5281 14.465 24.1394 14.4555C25.7139 14.4555 26.9477 13.1667 26.9477 11.5343C26.9477 9.90194 25.7153 8.61321 24.1394 8.61321C23.5011 8.60174 22.8815 8.82896 22.4018 9.25041V8.72776H21.085L21.0893 16.1236ZM23.9763 9.67999C24.9553 9.67999 25.6939 10.4833 25.6939 11.5415C25.6939 12.5997 24.9553 13.403 23.9763 13.403C22.9972 13.403 22.2587 12.5997 22.2587 11.5415C22.2587 10.4833 22.9886 9.67999 23.9763 9.67999Z",
						fill: "#00DE5A"
					})
				})]
			})
		})
	}) }), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_13_5710_npay_dark",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 33.4701,
			height: 11.4187,
			fill: "white",
			transform: "translate(7 6)"
		})
	}) })]
});
export default SvgNpay;
